import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import LinkedResultsTabState from './LinkedResultsTabState';
import {LinkedResultsView} from './LinkedResultsView';

export default class LinkedResultsTabView extends BufferTabView<LinkedResultsTabState> {
  render(): this {
    const fileId = this.model.get('fileId');
    const filters = this.model.get('filters');
    const resultType = this.model.get('resultType');

    ReduxDOMRender.renderToDOM(
      <LinkedResultsView fileId={fileId} filters={filters} resultType={resultType} />,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<LinkedResultsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

LinkedResultsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
